import http from '../http'

export default {
  // 上传文件
  uploadSingle(data: object) {
    return http.post('/oss/oss/upload/single/name', data)
  },
}
